import { useState } from 'react';
import Modal from './Modal';
import ModalTitle from './ModalTitle';

const DeleteWarningModal = ({
  isOpen,
  onClose,
  onConfirm,
  confirmText = 'Verwijderen',
  warningText = 'Weet je zeker dat je dit item wilt verwijderen?'
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    setIsDeleting(false);
    setError('');
    onClose();
  };

  const onDeleteError = (error) => {
    setError(error);
    setIsDeleting(false);
  };

  const onDeleteSuccess = () => {
    setError('');
    setIsDeleting(true);
    handleClose();
  };

  const handleConfirm = () => {
    setError('');
    setIsDeleting(true);
    onConfirm(onDeleteError, onDeleteSuccess);
  };

  return (
    <Modal
      className="spo-o-attachment-upload-modal"
      title={<ModalTitle hasError title="Opgelet!" />}
      isOpen={isOpen}
      isSubmitting={isDeleting}
      onClose={handleClose}
      onConfirm={handleConfirm}
      onConfirmLabel={confirmText}
      onConfirmIcon="ai-bin"
      onConfirmType="danger"
    >
      <div className="u-flex u-text-danger">{error || warningText}</div>
    </Modal>
  );
};

export default DeleteWarningModal;
